export default {
	title: 'settings',
	components: [
		{ title: 'input_output', component: 'input_output_010' },
		{ title: 'input_type', component: 'input_type_per_id_g2' },
		{
			title: 'enable_input',
			component: 'enable_input_per_id_g2',
			min_ver: '1.0.7',
		},
		{ title: 'invert_switch', component: 'invert_switch_per_id_g2' },
		{ title: 'dimming', component: 'dimming_behavior_g2' },
		{ title: 'button_fade_rate', component: 'button_fade_rate_g2' },
		{
			title: 'min_brightness_on_toggle',
			component: 'min_brightness_on_toggle_g2',
		},
		{ title: 'dali_configuration', component: 'dali_configuration' },
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
